import { instance } from "libs/api";

import { ApiRoutesStaff } from "../../constants";
import { StaffManagerListItem } from "../../staff.types";
import { CreateStaffManagerRequestBody } from "./createStaffManager.types";

export const requestCreateStaffManager = async (
  body: CreateStaffManagerRequestBody
): Promise<StaffManagerListItem> => {
  return await instance.post(ApiRoutesStaff.StaffManager, body);
};
